import { GetBodyTypesResponse } from "@/app/api/body-types/route";
import { getBodyTypesRequestSchema } from "@/lib/schemas/body-types";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const BODY_TYPES_ENDPOINT = "/api/body-types";

export const invalidateBodyTypesQuery =
  createInvalidateQuery(BODY_TYPES_ENDPOINT);

export const useBodyTypesQuery = createQueryHook<GetBodyTypesResponse>(
  BODY_TYPES_ENDPOINT,
  getBodyTypesRequestSchema,
);
